import React, { useId } from 'react';
import classnames from 'classnames';

import Show from 'components/Show';

const Checkbox = ({ readOnly, label, name, value, onChange, className, inputClassName, small, inline }) => {
	// Generate random id once
	const id = useId();

	// Container's classnames
	const containerClassName = classnames(
		inline && 'flex justify-end flex-row-reverse items-center',
		!inline && 'space-y-1',
		className
	);

	// Input's classnames
	const elementClassName = classnames(
		'appearance-none block bg-transparent border border-neutral-200 text-neutral-200 dark:border-neutral-700 dark:text-neutral-700 dark:checked:border-amber-500 dark:checked:text-amber-500 rounded-lg bg-white focus:border-0 focus:ring focus:ring-amber-500 focus:border-transparent cursor-pointer transition-all checked:border-amber-500 checked:text-amber-500',
		!small && 'w-9 h-9',
		small && 'w-7 h-7',
		inputClassName
	);

	// Label's classnames
	const labelClassName = classnames(
		'text-sm font-bold text-neutral-800 dark:text-white transition-colors',
		inline && 'ml-2',
		!inline && 'mb-1'
	);

	// Handle input's value change
	const handle = (event) => {
		onChange({
			name,
			value: event.target.checked
		});
	};

	return (
		<div className={containerClassName}>
			{/* Show label only if passed */}
			<Show if={label}>
				<label
					htmlFor={id}
					className={labelClassName}
				>
					{label}
				</label>
			</Show>

			<input
				id={id}
				type="checkbox"
				name={name}
				checked={value}
				onChange={handle}
				disabled={readOnly}
				className={elementClassName}
			/>
		</div>
	);
};

export default Checkbox;